import { createContext } from 'react';
import {
  KpiMappings,
  SourceMapping,
  AccountInfo
} from '@blisspointmedia/bpm-types/dist/KpiMapping';

export interface KpiMappingsContextType {
  sourceIdMap: Record<string, number>;
  kpiOptions: Record<string, string[]>;
  kpiMappings: KpiMappings;
  sourcesWithKpis: string[];
  sourceToPrettyName: Record<string, string>;
  accountInfoBySource: Record<string, AccountInfo[]>;
  rawSourceKpiCounts: Record<string, unknown>;
  kpiCountsLoading: boolean;
  lags: Record<string, string>;
  editMode: boolean;
}

export const KpiMappingsContext = createContext<KpiMappingsContextType>({
  sourceIdMap: {},
  kpiOptions: {},
  kpiMappings: {},
  sourcesWithKpis: [],
  sourceToPrettyName: {},
  accountInfoBySource: {},
  rawSourceKpiCounts: {},
  kpiCountsLoading: false,
  lags: {},
  editMode: false
});

export interface HandleCrossChannelKpiNameEdit {
  id: number;
  name: string;
}

export interface HandleLagEditInput {
  source: string;
  lag: string;
}

export interface HandleKpiEditInput {
  key: string;
  mappings: SourceMapping[];
}

export interface HandleNewRowInput {
  crossChannelKpiId: string;
  kpiLabel: string;
  sourceLabel: string;
  isCrossChannelKpiLabel: boolean;
  sourceMappings?: SourceMapping[];
  accountId?: string;
}

interface CombinedCrossChannelKpi {
  crossChannelKpiLabel: string;
  crossChannelKpiId: string | number;
  isNewRow?: boolean;
}

export type CombinedCrossChannelKpis = CombinedCrossChannelKpi[];

export interface KpiFunnel {
  id: number;
  name: string;
  kpis: string[];
  isDefault: boolean;
}

/**
 * Concatenation of the Cross Channel KPI ID, source, and account ID
 */
export const makeEditKey = ({
  crossChannelKpiId,
  source,
  accountId
}: {
  crossChannelKpiId: number | string;
  source: string;
  accountId: string;
}): string => `${crossChannelKpiId}_${source}_${accountId}`;
